import React from 'react';

import { hideGlobalError } from '#/reduxState/exchange/errorModalReducer';
import { staticDispatch, useSelector } from '#/reduxState/store';

import ErrorModal from './ErrorModal';

export default function ErrorOverlayModal() {
  const { errorMessage, errorType, subMessage } = useSelector(
    state => state.exchange.errorModal
  );
  return errorMessage ? (
    <ErrorModal
      onClose={() => staticDispatch(hideGlobalError())}
      errorMessage={errorMessage}
      errorType={errorType}
      subMessage={subMessage}
    />
  ) : null;
}
